module.exports = __webpack_public_path__ + "static/sport/swiper-1.b2cc425.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport4/swiper-1.png
// module id = nY4q
// module chunks = 0